import React from 'react';

const DLSOperating = () => (
  <svg
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 48 48"
    // style="enable-background:new 0 0 48 48;"
    fill="currentColor"
  >
    <path
      className="st0"
      d="M27.3,23.1c0.6-1,1-2,1.3-3.1H32v-6h-3.4c-0.3-1.1-0.7-2.1-1.3-3.1l2.4-2.4l-4.2-4.2l-2.4,2.4
	c-1-0.6-2-1-3.1-1.3V2h-6v3.4c-1.1,0.3-2.1,0.7-3.1,1.3L8.5,4.3L4.3,8.5l2.4,2.4c-0.6,1-1,2-1.3,3.1H2v6h3.4
	c0.3,1.1,0.7,2.1,1.3,3.1l-2.4,2.4l4.2,4.2l2.4-2.4c0.9,0.6,2,1,3.1,1.3V32h6v-3.4c1.1-0.3,2.1-0.7,3.1-1.3l2.4,2.4l4.2-4.2
	L27.3,23.1z M17,21c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S19.2,21,17,21z M46,38v-4h-3.3c-0.1-0.5-0.3-0.9-0.5-1.3l2.3-2.3l-2.8-2.8
	l-2.3,2.3c-0.4-0.2-0.9-0.4-1.3-0.5V26h-4v3.3c-0.5,0.1-0.9,0.3-1.3,0.5l-2.3-2.3l-2.8,2.8l2.3,2.3c-0.2,0.4-0.4,0.9-0.5,1.3H26v4
	h3.3c0.1,0.5,0.3,0.9,0.5,1.3l-2.3,2.3l2.8,2.8l2.3-2.3c0.4,0.2,0.9,0.4,1.3,0.5V46h4v-3.3c0.5-0.1,0.9-0.3,1.3-0.5l2.3,2.3l2.8-2.8
	l-2.3-2.3c0.2-0.4,0.4-0.9,0.5-1.3H46z M36,38c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S37.1,38,36,38z"
    />
  </svg>
);

export default DLSOperating;
